// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__m8Vdf","mainWrapper":"Layout_mainWrapper__wl-5M","withSidebar":"Layout_withSidebar__RkOCq","content":"Layout_content__-XVhO"};